import { SECTIONS } from "@/lib/sections";
import FeeDialog from "@/components/FeeDialog";
import FeeMemberCard from "@/components/FeeMemberCard";
import useFees from "@/hooks/useFees";

function FeeSection({ section: s, members, fees }) {
  if (members.length === 0) return null;
  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <span className={`scout-tag ${s.tag}`}>{s.label}</span>
        <span className="text-sm text-muted-foreground">{members.length} members</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {members.map((m) => (
          <FeeMemberCard key={m.id} member={m} payments={fees.byMember[m.id] || []} total={fees.totalsByMember[m.id] || 0}
            overdue={fees.overdueMap[m.id]} reminding={fees.reminding === m.id} onLog={fees.openFor} onRemind={fees.remind} onDelete={fees.del} onResendReceipt={fees.resendReceipt} />
        ))}
      </div>
    </div>
  );
}

export default function Fees() {
  const fees = useFees();
  return (
    <div className="space-y-6" data-testid="fees-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Membership fees</div>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight" style={{ fontFamily: "Outfit" }}>Fees Tracker</h1>
        <p className="text-muted-foreground text-sm mt-1">Log weekly, monthly or annual payments — each entry is added to the payments ledger automatically.</p>
      </div>
      {SECTIONS.map((s) => (
        <FeeSection key={s.value} section={s} members={fees.members.filter((m) => m.section === s.value)} fees={fees} />
      ))}
      <FeeDialog open={fees.open} onOpenChange={fees.setOpen} form={fees.form} setForm={fees.setForm} member={fees.currentMember} onSave={fees.save} />
    </div>
  );
}
